import { render, staticRenderFns } from "./UiListItem.vue?vue&type=template&id=95c12754&scoped=true&"
import script from "./UiListItem.vue?vue&type=script&lang=ts&"
export * from "./UiListItem.vue?vue&type=script&lang=ts&"
import style0 from "./UiListItem.vue?vue&type=style&index=0&id=95c12754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c12754",
  null
  
)

export default component.exports